var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "slideContainer", staticClass: "profitability" },
    [
      _c("Title", {
        attrs: { zhTitle: "监管指标", enTitle: "Regulatory Indicators" },
      }),
      _vm.types == 1
        ? _c("div", { staticClass: "cards1" }, [
            _vm.array[0] === 1
              ? _c("div", { staticClass: "card" }, [
                  _vm.language === "zh"
                    ? _c("div", { staticClass: "zh" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("核心一级资本充足率"),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n          " + _vm._s(_vm.hxyjzbczl)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.hxyjzbczlUnit)),
                          ]),
                        ]),
                      ])
                    : _vm.language === "en"
                    ? _c("div", { staticClass: "en" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("Core Tier 1 Capital Adequacy Ratio"),
                        ]),
                        _c(
                          "div",
                          {
                            class:
                              _vm.hxyjzbczl === "Undisclosed" ? "num1" : "num",
                          },
                          [
                            _vm._v("\n          " + _vm._s(_vm.hxyjzbczl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.hxyjzbczlUnit)),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { ref: "chart1", staticClass: "charts" }),
                ])
              : _vm._e(),
            _vm.array[1] === 1
              ? _c("div", { staticClass: "card" }, [
                  _vm.language === "zh"
                    ? _c("div", { staticClass: "zh" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("一级资本充足率"),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n          " + _vm._s(_vm.yjzbczl)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.yjzbczlUnit)),
                          ]),
                        ]),
                      ])
                    : _vm.language === "en"
                    ? _c("div", { staticClass: "en" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("Tier 1 Capital Adequacy Ratio"),
                        ]),
                        _c(
                          "div",
                          {
                            class:
                              _vm.yjzbczl === "Undisclosed" ? "num1" : "num",
                          },
                          [
                            _vm._v("\n          " + _vm._s(_vm.yjzbczl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.yjzbczlUnit)),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { ref: "chart2", staticClass: "charts" }),
                ])
              : _vm._e(),
            _vm.array[2] === 1
              ? _c("div", { staticClass: "card" }, [
                  _vm.language === "zh"
                    ? _c("div", { staticClass: "zh" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("资本充足率"),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n          " + _vm._s(_vm.zbczl)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.zbczlUnit)),
                          ]),
                        ]),
                      ])
                    : _vm.language === "en"
                    ? _c("div", { staticClass: "en" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("Capital Adequacy Ratio"),
                        ]),
                        _c(
                          "div",
                          {
                            class: _vm.zbczl === "Undisclosed" ? "num1" : "num",
                          },
                          [
                            _vm._v("\n          " + _vm._s(_vm.zbczl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.zbczlUnit)),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { ref: "chart3", staticClass: "charts" }),
                ])
              : _vm._e(),
            _vm.array[3] === 1
              ? _c("div", { staticClass: "card" }, [
                  _vm.language === "zh"
                    ? _c("div", { staticClass: "zh" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("杠杆率"),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n          " + _vm._s(_vm.ggl)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.gglUnit)),
                          ]),
                        ]),
                      ])
                    : _vm.language === "en"
                    ? _c("div", { staticClass: "en" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("Leverage Ratio"),
                        ]),
                        _c(
                          "div",
                          { class: _vm.ggl === "Undisclosed" ? "num1" : "num" },
                          [
                            _vm._v("\n          " + _vm._s(_vm.ggl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.gglUnit)),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { ref: "chart4", staticClass: "charts" }),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm.types == 2
        ? _c("div", { staticClass: "cards" }, [
            _vm.array[0] === 1
              ? _c("div", { staticClass: "card2" }, [
                  _vm.language === "zh"
                    ? _c("div", { staticClass: "zh" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("核心一级资本充足率"),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n          " + _vm._s(_vm.hxyjzbczl)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.hxyjzbczlUnit)),
                          ]),
                        ]),
                      ])
                    : _vm.language === "en"
                    ? _c("div", { staticClass: "en" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("Core Tier 1 Capital Adequacy Ratio"),
                        ]),
                        _c(
                          "div",
                          {
                            class:
                              _vm.hxyjzbczl === "Undisclosed" ? "num1" : "num",
                          },
                          [
                            _vm._v("\n          " + _vm._s(_vm.hxyjzbczl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.hxyjzbczlUnit)),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { ref: "chart1", staticClass: "charts2" }),
                ])
              : _vm._e(),
            _vm.array[1] === 1
              ? _c("div", { staticClass: "card2" }, [
                  _vm.language === "zh"
                    ? _c("div", { staticClass: "zh" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("一级资本充足率"),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n          " + _vm._s(_vm.yjzbczl)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.yjzbczlUnit)),
                          ]),
                        ]),
                      ])
                    : _vm.language === "en"
                    ? _c("div", { staticClass: "en" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("Tier 1 Capital Adequacy Ratio"),
                        ]),
                        _c(
                          "div",
                          {
                            class:
                              _vm.yjzbczl === "Undisclosed" ? "num1" : "num",
                          },
                          [
                            _vm._v("\n          " + _vm._s(_vm.yjzbczl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.yjzbczlUnit)),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { ref: "chart2", staticClass: "charts2" }),
                ])
              : _vm._e(),
            _vm.array[2] === 1
              ? _c("div", { staticClass: "card2" }, [
                  _vm.language === "zh"
                    ? _c("div", { staticClass: "zh" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("资本充足率"),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n          " + _vm._s(_vm.zbczl)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.zbczlUnit)),
                          ]),
                        ]),
                      ])
                    : _vm.language === "en"
                    ? _c("div", { staticClass: "en" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("Capital Adequacy Ratio"),
                        ]),
                        _c(
                          "div",
                          {
                            class: _vm.zbczl === "Undisclosed" ? "num1" : "num",
                          },
                          [
                            _vm._v("\n          " + _vm._s(_vm.zbczl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.zbczlUnit)),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { ref: "chart3", staticClass: "charts2" }),
                ])
              : _vm._e(),
            _vm.array[3] === 1
              ? _c("div", { staticClass: "card2" }, [
                  _vm.language === "zh"
                    ? _c("div", { staticClass: "zh" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("杠杆率"),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n          " + _vm._s(_vm.ggl)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.gglUnit)),
                          ]),
                        ]),
                      ])
                    : _vm.language === "en"
                    ? _c("div", { staticClass: "en" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("Leverage Ratio"),
                        ]),
                        _c(
                          "div",
                          { class: _vm.ggl === "Undisclosed" ? "num1" : "num" },
                          [
                            _vm._v("\n          " + _vm._s(_vm.ggl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.gglUnit)),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { ref: "chart4", staticClass: "charts2" }),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm.types == 3
        ? _c("div", { staticClass: "cards" }, [
            _vm.array[0] === 1
              ? _c("div", { staticClass: "card3" }, [
                  _vm.language === "zh"
                    ? _c("div", { staticClass: "zh" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("核心一级资本充足率"),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n          " + _vm._s(_vm.hxyjzbczl)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.hxyjzbczlUnit)),
                          ]),
                        ]),
                      ])
                    : _vm.language === "en"
                    ? _c("div", { staticClass: "en" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text-long" }, [
                          _vm._v("Core Tier 1 Capital Adequacy Ratio"),
                        ]),
                        _c(
                          "div",
                          {
                            class:
                              _vm.hxyjzbczl === "Undisclosed"
                                ? "num1-long"
                                : "num-long",
                          },
                          [
                            _vm._v("\n          " + _vm._s(_vm.hxyjzbczl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.hxyjzbczlUnit)),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { ref: "chart1", staticClass: "charts3" }),
                ])
              : _vm._e(),
            _vm.array[1] === 1
              ? _c("div", { staticClass: "card3" }, [
                  _vm.language === "zh"
                    ? _c("div", { staticClass: "zh" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("一级资本充足率"),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n          " + _vm._s(_vm.yjzbczl)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.yjzbczlUnit)),
                          ]),
                        ]),
                      ])
                    : _vm.language === "en"
                    ? _c("div", { staticClass: "en" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text-long" }, [
                          _vm._v("Tier 1 Capital Adequacy Ratio"),
                        ]),
                        _c(
                          "div",
                          {
                            class:
                              _vm.yjzbczl === "Undisclosed"
                                ? "num1-long"
                                : "num-long",
                          },
                          [
                            _vm._v("\n          " + _vm._s(_vm.yjzbczl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.yjzbczlUnit)),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { ref: "chart2", staticClass: "charts3" }),
                ])
              : _vm._e(),
            _vm.array[2] === 1
              ? _c("div", { staticClass: "card3" }, [
                  _vm.language === "zh"
                    ? _c("div", { staticClass: "zh" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("资本充足率"),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n          " + _vm._s(_vm.zbczl)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.zbczlUnit)),
                          ]),
                        ]),
                      ])
                    : _vm.language === "en"
                    ? _c("div", { staticClass: "en" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text-long" }, [
                          _vm._v("Capital Adequacy Ratio"),
                        ]),
                        _c(
                          "div",
                          {
                            class:
                              _vm.zbczl === "Undisclosed"
                                ? "num1-long"
                                : "num-long",
                          },
                          [
                            _vm._v("\n          " + _vm._s(_vm.zbczl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.zbczlUnit)),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { ref: "chart3", staticClass: "charts3" }),
                ])
              : _vm._e(),
            _vm.array[3] === 1
              ? _c("div", { staticClass: "card3" }, [
                  _vm.language === "zh"
                    ? _c("div", { staticClass: "zh" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("杠杆率"),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n          " + _vm._s(_vm.ggl)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.gglUnit)),
                          ]),
                        ]),
                      ])
                    : _vm.language === "en"
                    ? _c("div", { staticClass: "en" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text-long" }, [
                          _vm._v("Leverage Ratio"),
                        ]),
                        _c(
                          "div",
                          {
                            class:
                              _vm.ggl === "Undisclosed"
                                ? "num1-long"
                                : "num-long",
                          },
                          [
                            _vm._v("\n          " + _vm._s(_vm.ggl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.gglUnit)),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { ref: "chart4", staticClass: "charts3" }),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm.types == 4
        ? _c("div", { staticClass: "cards4" }, [
            _c("div", { staticClass: "column" }, [
              _c("div", { staticClass: "card4" }, [
                _vm.language === "zh"
                  ? _c(
                      "div",
                      { staticClass: "zh", staticStyle: { width: "149px" } },
                      [
                        _c("div", { staticClass: "card-title-long" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text-long" }, [
                          _vm._v("核心一级资本充足率"),
                        ]),
                        _c("div", { staticClass: "num-long" }, [
                          _vm._v("\n            " + _vm._s(_vm.hxyjzbczl)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.hxyjzbczlUnit)),
                          ]),
                        ]),
                      ]
                    )
                  : _vm.language === "en"
                  ? _c(
                      "div",
                      { staticClass: "en", staticStyle: { width: "149px" } },
                      [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text-long" }, [
                          _vm._v("Core Tier 1 Capital Adequacy Ratio"),
                        ]),
                        _c(
                          "div",
                          {
                            class:
                              _vm.hxyjzbczl === "Undisclosed" ? "num1" : "num",
                          },
                          [
                            _vm._v("\n            " + _vm._s(_vm.hxyjzbczl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.hxyjzbczlUnit)),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _c("div", { staticClass: "line" }),
                _c("div", { ref: "chart1", staticClass: "charts4" }),
              ]),
              _c("div", { staticClass: "card4" }, [
                _vm.language === "zh"
                  ? _c(
                      "div",
                      { staticClass: "zh", staticStyle: { width: "149px" } },
                      [
                        _c("div", { staticClass: "card-title-long" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                          ),
                        ]),
                        _vm._m(0),
                        _c("div", { staticClass: "num-long" }, [
                          _vm._v("\n            " + _vm._s(_vm.yjzbczl)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.yjzbczlUnit)),
                          ]),
                        ]),
                      ]
                    )
                  : _vm.language === "en"
                  ? _c(
                      "div",
                      { staticClass: "en", staticStyle: { width: "149px" } },
                      [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text-long" }, [
                          _vm._v("Tier 1 Capital Adequacy Ratio"),
                        ]),
                        _c(
                          "div",
                          {
                            class:
                              _vm.yjzbczl === "Undisclosed" ? "num1" : "num",
                          },
                          [
                            _vm._v("\n            " + _vm._s(_vm.yjzbczl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.yjzbczlUnit)),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _c("div", { staticClass: "line" }),
                _c("div", { ref: "chart2", staticClass: "charts4" }),
              ]),
            ]),
            _c("div", { staticClass: "column mt" }, [
              _c("div", { staticClass: "card4" }, [
                _vm.language === "zh"
                  ? _c(
                      "div",
                      { staticClass: "zh", staticStyle: { width: "149px" } },
                      [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("资本充足率"),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n            " + _vm._s(_vm.zbczl)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.zbczlUnit)),
                          ]),
                        ]),
                      ]
                    )
                  : _vm.language === "en"
                  ? _c(
                      "div",
                      { staticClass: "en", staticStyle: { width: "149px" } },
                      [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("Capital Adequacy Ratio"),
                        ]),
                        _c(
                          "div",
                          {
                            class: _vm.zbczl === "Undisclosed" ? "num1" : "num",
                          },
                          [
                            _vm._v("\n            " + _vm._s(_vm.zbczl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.zbczlUnit)),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _c("div", { staticClass: "line" }),
                _c("div", { ref: "chart3", staticClass: "charts4" }),
              ]),
              _c("div", { staticClass: "card4" }, [
                _vm.language === "zh"
                  ? _c(
                      "div",
                      { staticClass: "zh", staticStyle: { width: "149px" } },
                      [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("杠杆率"),
                        ]),
                        _c("div", { staticClass: "num" }, [
                          _vm._v("\n            " + _vm._s(_vm.ggl)),
                          _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.gglUnit)),
                          ]),
                        ]),
                      ]
                    )
                  : _vm.language === "en"
                  ? _c(
                      "div",
                      { staticClass: "en", staticStyle: { width: "149px" } },
                      [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(_vm.jsonData.year) +
                              _vm._s(_vm.periodNameEng)
                          ),
                        ]),
                        _c("div", { staticClass: "card-text" }, [
                          _vm._v("Leverage Ratio"),
                        ]),
                        _c(
                          "div",
                          { class: _vm.ggl === "Undisclosed" ? "num1" : "num" },
                          [
                            _vm._v("\n            " + _vm._s(_vm.ggl)),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.gglUnit)),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _c("div", { staticClass: "line" }),
                _c("div", { ref: "chart4", staticClass: "charts4" }),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-text-long" }, [
      _vm._v("一级资本"),
      _c("br"),
      _vm._v("充足率"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }